import { createActionGroup, props } from '@ngrx/store';
import { HistorialMedico } from './historial-medico.state';

export const HistorialMedicoActions = createActionGroup({
  source: 'HistorialMedico',
  events: {
    'Load Record': props<{ studentId: string }>(),
    'Load Record Success': props<{ record: HistorialMedico }>(),
    'Load Record Failure': props<{ error: string }>(),

    'Save Record': props<{ studentId: string; record: HistorialMedico }>(),
    'Save Record Success': props<{ record: HistorialMedico }>(),
    'Save Record Failure': props<{ error: string }>(),
  },
});
